import React from 'react';
import { Pressable } from 'react-native';
import { Icon } from '@ant-design/react-native';
import { colorPalette } from '@shared/config/colorsConfig';
import { CHAT_COMPOSER_ICON_SIZE } from '../../constants';
import type { TChatSendButtonProps } from '../../types';

export const ChatSendButton = ({ enabled, label, onPress }: TChatSendButtonProps) => (
    <Pressable
        onPress={onPress}
        disabled={!enabled}
        accessibilityRole="button"
        accessibilityLabel={label}
        className={`w-12 h-12 rounded-lg items-center justify-center ${enabled ? 'bg-secondary-600' : 'bg-gray-400'}`}
    >
        <Icon name="right" size={CHAT_COMPOSER_ICON_SIZE} color={colorPalette.white} />
    </Pressable>
);
